// Copies a table to the clipboard in BOTH rich (text/html) and plain (TSV)
// formats so it pastes cleanly into Word/Google Docs/email (as a real table)
// and into Excel/Sheets (tab-separated → columns).
const escapeHtml = (s) =>
  String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

const cleanCell = (s) =>
  String(s ?? "").replace(/\t/g, " ").replace(/\r?\n/g, " ").trim();

export async function copyTableToClipboard({ headers, rows }) {
  const html =
    `<table border="1" cellspacing="0" cellpadding="6" style="border-collapse:collapse;font-family:Arial,sans-serif;font-size:13px">` +
    `<thead><tr>${headers
      .map((h) => `<th style="background:#f1f5f9;text-align:left;padding:6px 10px;border:1px solid #cbd5e1">${escapeHtml(h)}</th>`)
      .join("")}</tr></thead>` +
    `<tbody>${rows
      .map(
        (r) =>
          `<tr>${r
            .map((c) => `<td style="padding:6px 10px;border:1px solid #e2e8f0">${escapeHtml(cleanCell(c))}</td>`)
            .join("")}</tr>`
      )
      .join("")}</tbody></table>`;

  const tsv = [
    headers.map(cleanCell).join("\t"),
    ...rows.map((r) => r.map(cleanCell).join("\t")),
  ].join("\n");

  try {
    if (navigator.clipboard && window.ClipboardItem) {
      await navigator.clipboard.write([
        new window.ClipboardItem({
          "text/html": new Blob([html], { type: "text/html" }),
          "text/plain": new Blob([tsv], { type: "text/plain" }),
        }),
      ]);
      return true;
    }
    await navigator.clipboard.writeText(tsv);
    return true;
  } catch {
    // Last-resort fallback for older browsers / insecure contexts.
    try {
      const ta = document.createElement("textarea");
      ta.value = tsv;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      return true;
    } catch {
      return false;
    }
  }
}
